/* SES Palma · portal de mayoristas · tarifa por SKU/EAN, descargas y recepción de envíos.
   - Tarifa: cada estilo se despliega en color × talla con SKU, EAN (del CRM), precio mayorista y PVP;
     «Descargar tarifa» en CSV o Excel (se genera en el navegador).
   - Pedidos: «Descargar» cada pedido en PDF (estilo del portal) o Excel; envíos del pedido y
     «Recepcionar»: el comprador confirma lo recibido por línea y marca incidencias (una vez por envío).
   El portal (ses-b2b-portal.js) llama a enhancePrices / enhanceOrders tras pintar cada vista.
   Las librerías (SheetJS, jsPDF) se cargan solo al descargar. */
(function () {
  'use strict';
  const B = window.SESB2B;
  if (!B) return;
  const { esc, ICON, t } = B;

  B.extend({
    ff_dl_prices:  { es: 'Descargar lista de precios', en: 'Download price list', fr: 'Télécharger la liste de prix', it: 'Scarica listino prezzi' },
    ff_csv:        { es: 'CSV', en: 'CSV', fr: 'CSV', it: 'CSV' },
    ff_xlsx:       { es: 'Excel', en: 'Excel', fr: 'Excel', it: 'Excel' },
    ff_pdf:        { es: 'PDF', en: 'PDF', fr: 'PDF', it: 'PDF' },
    ff_dl_as:      { es: 'Descargar {what} en {fmt}', en: 'Download {what} as {fmt}', fr: 'Télécharger {what} en {fmt}', it: 'Scarica {what} in {fmt}' },
    ff_preparing:  { es: 'Preparando el archivo…', en: 'Preparing the file…', fr: 'Préparation du fichier…', it: 'Preparazione del file…' },
    ff_dl_error:   { es: 'No se pudo generar el archivo. Inténtalo de nuevo.', en: 'The file could not be generated. Please try again.', fr: 'Le fichier n\'a pas pu être généré. Réessayez.', it: 'Impossibile generare il file. Riprova.' },
    ff_show_skus:  { es: 'Ver SKU y EAN', en: 'Show SKUs and EANs', fr: 'Voir SKU et EAN', it: 'Vedi SKU ed EAN' },
    ff_hide_skus:  { es: 'Ocultar SKU y EAN', en: 'Hide SKUs and EANs', fr: 'Masquer SKU et EAN', it: 'Nascondi SKU ed EAN' },
    ff_sku:        { es: 'SKU', en: 'SKU', fr: 'SKU', it: 'SKU' },
    ff_ean:        { es: 'EAN', en: 'EAN', fr: 'EAN', it: 'EAN' },
    ff_style:      { es: 'Estilo', en: 'Style', fr: 'Modèle', it: 'Modello' },
    ff_style_code: { es: 'Código estilo', en: 'Style code', fr: 'Code modèle', it: 'Codice modello' },
    ff_color:      { es: 'Color', en: 'Colour', fr: 'Couleur', it: 'Colore' },
    ff_size:       { es: 'Talla', en: 'Size', fr: 'Taille', it: 'Taglia' },
    ff_wholesale:  { es: 'Precio mayorista', en: 'Wholesale price', fr: 'Prix de gros', it: 'Prezzo all\'ingrosso' },
    ff_deposit:    { es: 'Precio depósito', en: 'Consignment price', fr: 'Prix dépôt', it: 'Prezzo conto vendita' },
    ff_rrp:        { es: 'PVP {country}', en: 'RRP {country}', fr: 'PVC {country}', it: 'Prezzo al pubblico {country}' },
    ff_currency:   { es: 'Moneda', en: 'Currency', fr: 'Devise', it: 'Valuta' },
    ff_vat_incl:   { es: 'IVA incl.', en: 'incl. VAT', fr: 'TTC', it: 'IVA incl.' },
    ff_units:      { es: '{n} uds', en: '{n} units', fr: '{n} pièces', it: '{n} pezzi' },
    ff_rcv_diff:   { es: 'Diferencia: {n}', en: 'Difference: {n}', fr: 'Écart : {n}', it: 'Differenza: {n}' },
    ff_qty:        { es: 'Uds', en: 'Units', fr: 'Pièces', it: 'Pezzi' },
    ff_shipped:    { es: 'Enviadas', en: 'Shipped', fr: 'Expédiées', it: 'Spedite' },
    ff_amount:     { es: 'Importe', en: 'Amount', fr: 'Montant', it: 'Importo' },
    ff_total:      { es: 'Total', en: 'Total', fr: 'Total', it: 'Totale' },
    ff_order:      { es: 'pedido {ref}', en: 'order {ref}', fr: 'commande {ref}', it: 'ordine {ref}' },
    ff_order_t:    { es: 'Pedido {ref}', en: 'Order {ref}', fr: 'Commande {ref}', it: 'Ordine {ref}' },
    ff_prices_t:   { es: 'Lista de precios {season}', en: '{season} price list', fr: 'Liste de prix {season}', it: 'Listino prezzi {season}' },
    ff_price_note: { es: 'Precios mayoristas, IVA no incluido. El importe final es el de la factura.', en: 'Wholesale list prices excl. VAT. The final amount is the one on the invoice.', fr: 'Prix de gros HT. Le montant final est celui de la facture.', it: 'Prezzi all\'ingrosso di listino IVA esclusa. L\'importo finale è quello della fattura.' },
    ff_invoiced:   { es: 'Importe facturado', en: 'Invoiced amount', fr: 'Montant facturé', it: 'Importo fatturato' },
    ff_order_value: { es: 'Valor del pedido', en: 'Order value', fr: 'Valeur de la commande', it: 'Valore dell\'ordine' },
    ff_date:       { es: 'Fecha', en: 'Date', fr: 'Date', it: 'Data' },
    ff_status:     { es: 'Estado', en: 'Status', fr: 'Statut', it: 'Stato' },
    ff_season:     { es: 'Temporada', en: 'Season', fr: 'Saison', it: 'Stagione' },
    ff_company:    { es: 'Empresa', en: 'Company', fr: 'Société', it: 'Azienda' },
    ff_generated:  { es: 'Generado el {date}', en: 'Generated on {date}', fr: 'Généré le {date}', it: 'Generato il {date}' },
    // envíos y recepción
    ff_shipments:  { es: 'Envíos', en: 'Shipments', fr: 'Expéditions', it: 'Spedizioni' },
    ff_shipment:   { es: 'Envío {ref}', en: 'Shipment {ref}', fr: 'Expédition {ref}', it: 'Spedizione {ref}' },
    ff_tracking:   { es: 'Seguimiento', en: 'Tracking', fr: 'Suivi', it: 'Tracking' },
    ff_receive:    { es: 'Recepcionar', en: 'Confirm receipt', fr: 'Réceptionner', it: 'Conferma ricezione' },
    ff_received_on:{ es: 'Recibido el {date}', en: 'Received on {date}', fr: 'Reçu le {date}', it: 'Ricevuto il {date}' },
    ff_received_inc:{ es: 'Recibido con incidencias el {date}', en: 'Received with issues on {date}', fr: 'Reçu avec incidents le {date}', it: 'Ricevuto con problemi il {date}' },
    ff_pending_rcv:{ es: 'Pendiente de recepcionar', en: 'Awaiting receipt', fr: 'À réceptionner', it: 'Da confermare' },
    ff_rcv_title:  { es: 'Recepcionar el envío {ref}', en: 'Confirm receipt of shipment {ref}', fr: 'Réceptionner l\'expédition {ref}', it: 'Conferma ricezione della spedizione {ref}' },
    ff_rcv_intro:  { es: 'Revisa lo que ha llegado. Si algo no cuadra, cambia la cantidad recibida o marca la incidencia y añade una nota. SES lo revisa antes de tocar nada.', en: 'Check what has arrived. If something does not match, change the received quantity or flag the issue and add a note. SES reviews it before changing anything.', fr: 'Vérifiez ce qui est arrivé. Si quelque chose ne correspond pas, modifiez la quantité reçue ou signalez l\'incident avec une note. SES vérifie avant toute modification.', it: 'Controlla cosa è arrivato. Se qualcosa non torna, cambia la quantità ricevuta o segnala il problema con una nota. SES lo verifica prima di modificare qualcosa.' },
    ff_rcv_date:   { es: 'Fecha de recepción', en: 'Date received', fr: 'Date de réception', it: 'Data di ricezione' },
    ff_rcv_sent:   { es: 'Enviadas', en: 'Sent', fr: 'Envoyées', it: 'Inviate' },
    ff_rcv_got:    { es: 'Recibidas', en: 'Received', fr: 'Reçues', it: 'Ricevute' },
    ff_rcv_issue:  { es: 'Incidencia', en: 'Issue', fr: 'Incident', it: 'Problema' },
    ff_rcv_note:   { es: 'Nota', en: 'Note', fr: 'Note', it: 'Nota' },
    ff_rcv_comment:{ es: 'Comentario para SES (opcional)', en: 'Comment for SES (optional)', fr: 'Commentaire pour SES (facultatif)', it: 'Commento per SES (facoltativo)' },
    ff_rcv_ok_all: { es: 'Todo conforme', en: 'Everything matches', fr: 'Tout est conforme', it: 'Tutto conforme' },
    ff_rcv_n_inc:  { es: 'Incidencias en {n} líneas', en: 'Issues on {n} lines', fr: 'Incidents sur {n} lignes', it: 'Problemi su {n} righe' },
    ff_rcv_n_inc1: { es: 'Incidencia en 1 línea', en: 'Issue on 1 line', fr: 'Incident sur 1 ligne', it: 'Problema su 1 riga' },
    ff_rcv_confirm:{ es: 'Confirmar recepción', en: 'Confirm receipt', fr: 'Confirmer la réception', it: 'Conferma ricezione' },
    ff_rcv_sending:{ es: 'Enviando…', en: 'Sending…', fr: 'Envoi…', it: 'Invio…' },
    ff_rcv_done:   { es: 'Recepción confirmada. Gracias.', en: 'Receipt confirmed. Thank you.', fr: 'Réception confirmée. Merci.', it: 'Ricezione confermata. Grazie.' },
    ff_rcv_done_inc:{ es: 'Recepción confirmada con incidencias. SES la revisará y te dirá algo.', en: 'Receipt confirmed with issues. SES will review it and get back to you.', fr: 'Réception confirmée avec incidents. SES va l\'examiner et revenir vers vous.', it: 'Ricezione confermata con problemi. SES la esaminerà e ti risponderà.' },
    ff_rcv_note_req:{ es: 'Añade una nota en las líneas con incidencia «Otra».', en: 'Add a note on lines flagged "Other".', fr: 'Ajoutez une note aux lignes signalées « Autre ».', it: 'Aggiungi una nota alle righe segnalate «Altro».' },
    ff_inc_none:   { es: 'Sin incidencia', en: 'No issue', fr: 'Aucun incident', it: 'Nessun problema' },
    ff_inc_MISSING:{ es: 'Falta', en: 'Missing', fr: 'Manquant', it: 'Mancante' },
    ff_inc_DAMAGED:{ es: 'Dañada', en: 'Damaged', fr: 'Abîmé', it: 'Danneggiato' },
    ff_inc_WRONG_SIZE:{ es: 'Talla equivocada', en: 'Wrong size', fr: 'Mauvaise taille', it: 'Taglia sbagliata' },
    ff_inc_WRONG_ITEM:{ es: 'Artículo equivocado', en: 'Wrong item', fr: 'Mauvais article', it: 'Articolo sbagliato' },
    ff_inc_OTHER:  { es: 'Otra', en: 'Other', fr: 'Autre', it: 'Altro' },
    err_already_received: { es: 'Este envío ya se había recepcionado.', en: 'This shipment had already been received.', fr: 'Cette expédition avait déjà été réceptionnée.', it: 'Questa spedizione era già stata confermata.' },
    err_invalid_date: { es: 'La fecha de recepción no es válida.', en: 'The date received is not valid.', fr: 'La date de réception n\'est pas valide.', it: 'La data di ricezione non è valida.' },
  });
  const INCIDENTS = ['MISSING', 'DAMAGED', 'WRONG_SIZE', 'WRONG_ITEM', 'OTHER'];
  const sb = () => B.sb();
  const SIZE_ORDER = ['XS', 'S', 'S/M', 'M', 'M/L', 'L', 'XL', 'XXL', 'U', 'Única'];
  const sizeIdx = (s) => { const i = SIZE_ORDER.indexOf(s); return i < 0 ? 99 : i; };
  const today = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };
  const slug = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'ses';
  const num = (v) => (v == null || v === '' || !isFinite(Number(v)) ? null : Number(v));

  /* ---------- datos ---------- */
  const eanCache = new Map(); // season -> Promise<Map<sku, ean>>
  function eans(season) {
    if (!eanCache.has(season)) {
      eanCache.set(season, B.selectAll(() => sb().from('portal_variant_codes').select('sku,ean').eq('season', season).order('sku'))
        .then((rows) => new Map(rows.filter((r) => r.ean).map((r) => [r.sku, r.ean])))
        .catch((e) => { eanCache.delete(season); throw e; }));
    }
    return eanCache.get(season);
  }

  /* ---------- librerías bajo demanda (cdnjs, versión fija) ---------- */
  const LIBS = {
    xlsx: ['https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js'],
    pdf: ['https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js'],
  };
  const loaded = new Map();
  function script(src) {
    if (!loaded.has(src)) {
      loaded.set(src, new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src; s.async = false; s.crossOrigin = 'anonymous';
        s.onload = resolve; s.onerror = () => { loaded.delete(src); reject(new Error('lib ' + src)); };
        document.head.appendChild(s);
      }));
    }
    return loaded.get(src);
  }
  async function lib(name) { for (const src of LIBS[name]) await script(src); }

  function saveBlob(blob, filename) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }
  function csvCell(v) {
    if (v == null) return '';
    const s = String(v);
    return /[",\n\r;]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }
  function downloadCsv(header, rows, filename) {
    const body = [header, ...rows].map((r) => r.map(csvCell).join(',')).join('\r\n');
    saveBlob(new Blob(['﻿' + body], { type: 'text/csv;charset=utf-8' }), filename + '.csv');
  }
  async function downloadXlsx(sheetName, header, rows, filename, widths) {
    await lib('xlsx');
    const ws = window.XLSX.utils.aoa_to_sheet([header, ...rows]);
    if (widths) ws['!cols'] = widths.map((w) => ({ wch: w }));
    // EAN y SKU como texto: Excel no debe convertirlos en número (se perderían ceros)
    const wb = window.XLSX.utils.book_new();
    window.XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
    window.XLSX.writeFile(wb, filename + '.xlsx');
  }
  // Marca un botón como ocupado mientras se genera el archivo; avisa si falla.
  async function busy(btn, root, fn) {
    if (btn.disabled) return;
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try { await fn(); }
    catch (e) { console.warn(e); B.toast(t('ff_dl_error'), 'err', { root }); }
    finally { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
  }

  /* ---------- tarifa ---------- */
  // ctx: { MAIN, root, catalog, styles:[{st}], bySku, rrp (Map cc|sku), countries, showDeposit, mainLabel, company, season }
  async function enhancePrices(ctx) {
    const table = ctx.MAIN.querySelector('.bp-prices');
    if (!table) return;
    const colspan = table.querySelector('thead tr').children.length;
    const codes = await eans(ctx.season).catch(() => new Map());
    if (!ctx.MAIN.contains(table)) return;
    const rowsFor = (st) => st.colors.flatMap((c) => c.sizes.slice().sort((a, b) => sizeIdx(a.size) - sizeIdx(b.size)).map((z) => {
      const p = ctx.bySku.get(z.sku);
      if (!p || !(Number(p.wholesale) > 0)) return null;
      return {
        st, color: c.name, hex: c.hex, size: z.size, sku: z.sku, ean: codes.get(z.sku) || '',
        w: Number(p.wholesale), dep: num(p.deposit), cur: p.currency || 'EUR',
        rr: ctx.countries.map((cc) => ctx.rrp.get(cc + '|' + z.sku) || null),
      };
    }).filter(Boolean));

    // botón por estilo + fila de detalle
    table.querySelectorAll('tbody tr[data-style]').forEach((tr) => {
      const st = ctx.catalog.find((x) => x.code === tr.dataset.style);
      if (!st) return;
      const id = 'pd-' + st.code.replace(/[^A-Za-z0-9_-]/g, '');
      const th = tr.querySelector('th');
      th.insertAdjacentHTML('beforeend', `<button type="button" class="b2b-btn b2b-btn--ghost ff-sku-toggle" aria-expanded="false" aria-controls="${id}">${esc(t('ff_show_skus'))}</button>`);
      const det = document.createElement('tr');
      det.className = 'ff-pr-detail';
      det.id = id;
      det.hidden = true;
      det.innerHTML = `<td colspan="${colspan}"></td>`;
      tr.after(det);
      th.querySelector('.ff-sku-toggle').addEventListener('click', (e) => {
        const b = e.currentTarget;
        const open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        b.textContent = t(open ? 'ff_show_skus' : 'ff_hide_skus');
        det.hidden = open;
        if (!open && !det.dataset.ready) {
          det.dataset.ready = '1';
          det.firstElementChild.innerHTML = skuTable(rowsFor(st), ctx);
        }
      });
    });
    // el buscador del portal oculta filas de estilo; su detalle va con ellas
    const qi = ctx.MAIN.querySelector('#bpPrQ');
    if (qi) qi.addEventListener('input', () => {
      table.querySelectorAll('tr.ff-pr-detail').forEach((d) => {
        const owner = d.previousElementSibling;
        const btn = owner && owner.querySelector('.ff-sku-toggle');
        d.hidden = !owner || owner.hidden || !btn || btn.getAttribute('aria-expanded') !== 'true';
      });
    });

    // descargas
    const bar = document.createElement('div');
    bar.className = 'ff-dl';
    bar.innerHTML = `<span class="ff-dl-label" id="ffPrDl">${esc(t('ff_dl_prices'))}</span>
      <div class="ff-dl-btns" role="group" aria-labelledby="ffPrDl">
        <button type="button" class="b2b-btn b2b-btn--secondary" data-ff="csv" aria-label="${esc(t('ff_dl_as', { what: t('ff_prices_t', { season: ctx.season }), fmt: 'CSV' }))}">${ICON.download}<span>${esc(t('ff_csv'))}</span></button>
        <button type="button" class="b2b-btn b2b-btn--secondary" data-ff="xlsx" aria-label="${esc(t('ff_dl_as', { what: t('ff_prices_t', { season: ctx.season }), fmt: 'Excel' }))}">${ICON.download}<span>${esc(t('ff_xlsx'))}</span></button>
      </div>`;
    const anchor = ctx.MAIN.querySelector('.bp-search') || table.closest('.bp-table-wrap');
    anchor.before(bar);
    const exportRows = () => {
      const all = ctx.styles.flatMap((x) => rowsFor(x.st));
      const header = [t('ff_sku'), t('ff_ean'), t('ff_style'), t('ff_style_code'), t('ff_color'), t('ff_size'), ctx.mainLabel || t('ff_wholesale')]
        .concat(ctx.showDeposit ? [t('ff_deposit')] : [])
        .concat(ctx.countries.map((cc) => `${t('ff_rrp', { country: B.countryName(cc) })}`))
        .concat([t('ff_currency')]);
      const rows = all.map((r) => [r.sku, r.ean, r.st.name, r.st.code, r.color, r.size, r.w]
        .concat(ctx.showDeposit ? [r.dep] : [])
        .concat(r.rr.map((x) => (x && Number(x.amount) > 0 ? Number(x.amount) : null)))
        .concat([r.cur]));
      return { header, rows };
    };
    const base = `SES-precios-${ctx.season}-${slug(ctx.company && ctx.company.name)}`;
    bar.querySelector('[data-ff="csv"]').addEventListener('click', (e) => busy(e.currentTarget, ctx.root, async () => {
      const x = exportRows(); downloadCsv(x.header, x.rows, base);
    }));
    bar.querySelector('[data-ff="xlsx"]').addEventListener('click', (e) => busy(e.currentTarget, ctx.root, async () => {
      const x = exportRows();
      await downloadXlsx(t('ff_prices_t', { season: ctx.season }), x.header, x.rows.map((r) => r.map((v, i) => (i < 2 && v != null ? String(v) : v))), base,
        [16, 15, 22, 12, 16, 7, 14].concat(ctx.showDeposit ? [14] : []).concat(ctx.countries.map(() => 14)).concat([8]));
    }));
  }

  function skuTable(rows, ctx) {
    if (!rows.length) return '';
    return `<div class="ff-sku-wrap"><table class="ff-sku">
      <thead><tr><th scope="col">${esc(t('ff_color'))}</th><th scope="col">${esc(t('ff_size'))}</th><th scope="col">${esc(t('ff_sku'))}</th><th scope="col">${esc(t('ff_ean'))}</th>
        <th scope="col" class="num">${esc(ctx.mainLabel || t('ff_wholesale'))}</th>${ctx.showDeposit ? `<th scope="col" class="num">${esc(t('ff_deposit'))}</th>` : ''}
        ${ctx.countries.map((cc) => `<th scope="col" class="num">${esc(t('ff_rrp', { country: cc }))}</th>`).join('')}</tr></thead>
      <tbody>${rows.map((r) => `<tr>
        <td><span class="bp-item">${r.hex ? `<i class="bp-dot" style="background:${B.safeHex(r.hex)}"></i>` : ''}<span>${esc(r.color)}</span></span></td>
        <td>${esc(r.size)}</td>
        <td class="ff-code">${esc(r.sku)}</td>
        <td class="ff-code">${r.ean ? esc(r.ean) : '<span class="bp-muted">·</span>'}</td>
        <td class="num u-tnum">${esc(B.fmtPrice(r.w, r.cur))}</td>
        ${ctx.showDeposit ? `<td class="num u-tnum">${r.dep ? esc(B.fmtPrice(r.dep, r.cur)) : '<span class="bp-muted">·</span>'}</td>` : ''}
        ${r.rr.map((x) => `<td class="num u-tnum">${x && Number(x.amount) > 0 ? esc(B.fmtPrice(x.amount, x.currency)) : '<span class="bp-muted">·</span>'}</td>`).join('')}
      </tr>`).join('')}</tbody></table></div>`;
  }

  /* ---------- pedidos: descargas y envíos ---------- */
  // ctx: { root, MAIN, orders, loadOrderLines(id), lineLabel(l), companyById(id), rerender() }
  async function enhanceOrders(ctx) {
    const items = [...ctx.MAIN.querySelectorAll('li.bp-order[data-order]')];
    if (!items.length) return;
    const byId = new Map(ctx.orders.map((o) => [o.id, o]));
    items.forEach((li) => {
      const o = byId.get(li.dataset.order);
      const acts = li.querySelector('.bp-order-actions');
      if (!o || !acts || o.status === 'CANCELLED') return;
      const what = t('ff_order', { ref: o.ref });
      acts.insertAdjacentHTML('beforeend', `
        <button type="button" class="b2b-btn b2b-btn--ghost" data-ff-pdf aria-label="${esc(t('ff_dl_as', { what, fmt: 'PDF' }))}">${ICON.download}<span>${esc(t('ff_pdf'))}</span></button>
        <button type="button" class="b2b-btn b2b-btn--ghost" data-ff-xlsx aria-label="${esc(t('ff_dl_as', { what, fmt: 'Excel' }))}">${ICON.download}<span>${esc(t('ff_xlsx'))}</span></button>`);
      acts.querySelector('[data-ff-pdf]').addEventListener('click', (e) => busy(e.currentTarget, ctx.root, () => orderPdf(o, ctx)));
      acts.querySelector('[data-ff-xlsx]').addEventListener('click', (e) => busy(e.currentTarget, ctx.root, () => orderXlsx(o, ctx)));
    });

    // envíos de estos pedidos (+ recepciones)
    const ids = ctx.orders.map((o) => o.id);
    let ships = [];
    try {
      ships = await B.selectAll(() => sb().from('portal_shipments')
        .select('id,company_id,order_id,ref,ship_date,status,tracking_number').in('order_id', ids).order('ship_date', { ascending: true }).order('id'));
    } catch (e) { console.warn('envíos no disponibles', e); return; }
    if (!ships.length || !ctx.MAIN.contains(items[0])) return;
    const sids = ships.map((s) => s.id);
    const [lines, receipts] = await Promise.all([
      B.selectAll(() => sb().from('portal_shipment_lines').select('shipment_id,sku,style_code,units_sent').in('shipment_id', sids).order('shipment_id').order('sku')).catch(() => []),
      B.selectAll(() => sb().from('portal_receipts').select('id,shipment_id,received_on,has_incidents').in('shipment_id', sids).order('id')).catch(() => []),
    ]);
    const linesBy = groupBy(lines, 'shipment_id');
    const rcvBy = new Map(receipts.map((r) => [r.shipment_id, r]));
    const shipsBy = groupBy(ships, 'order_id');
    items.forEach((li) => {
      const list = shipsBy.get(li.dataset.order);
      if (!list || !list.length) return;
      const box = document.createElement('div');
      box.className = 'ff-ships';
      box.innerHTML = `<p class="ff-ships-h">${esc(t('ff_shipments'))}</p><ul class="ff-ship-list" role="list">${list.map((s) => {
        const ls = linesBy.get(s.id) || [];
        const n = ls.reduce((a, l) => a + (l.units_sent || 0), 0);
        const r = rcvBy.get(s.id);
        const co = ctx.companyById(s.company_id);
        const canReceive = !r && co && co.can_order && !co.view_as && ls.length;
        const state = r ? `<span class="bp-badge bp-badge--${r.has_incidents ? 'wait' : 'ok'}">${r.has_incidents ? ICON.alert : ICON.check}<span>${esc(t(r.has_incidents ? 'ff_received_inc' : 'ff_received_on', { date: B.fmtDate(r.received_on) }))}</span></span>`
          : `<span class="bp-badge bp-badge--neutral"><span>${esc(t('ff_pending_rcv'))}</span></span>`;
        return `<li class="ff-ship">
          <span class="ff-ship-main"><strong>${esc(s.ref)}</strong>
            <span class="bp-muted u-tnum">${esc([s.ship_date ? B.fmtDate(s.ship_date) : '', t('ff_units', { n: B.fmtInt(n) }), s.tracking_number ? `${t('ff_tracking')}: ${s.tracking_number}` : ''].filter(Boolean).join(' · '))}</span></span>
          <span class="ff-ship-side">${state}${canReceive ? `<button type="button" class="b2b-btn b2b-btn--primary" data-ff-rcv="${esc(s.id)}">${ICON.check}<span>${esc(t('ff_receive'))}</span></button>` : ''}</span>
        </li>`;
      }).join('')}</ul>`;
      li.querySelector('.bp-order-actions').after(box);
      box.querySelectorAll('[data-ff-rcv]').forEach((b) => b.addEventListener('click', () => {
        const s = ships.find((x) => x.id === b.dataset.ffRcv);
        const ord = ctx.orders.find((x) => x.id === s.order_id);
        openReceipt(s, linesBy.get(s.id) || [], ctx, b, ord && ord.season);
      }));
    });
  }
  function groupBy(rows, key) {
    const m = new Map();
    rows.forEach((r) => { if (!m.has(r[key])) m.set(r[key], []); m.get(r[key]).push(r); });
    return m;
  }

  async function orderData(o, ctx) {
    const [lines, codes, prices] = await Promise.all([
      ctx.loadOrderLines(o.id),
      o.season ? eans(o.season).catch(() => new Map()) : Promise.resolve(new Map()),
      o.season ? B.selectAll(() => sb().from('portal_prices').select('sku,wholesale,currency').eq('company_id', o.company_id).eq('season', o.season).order('sku')).catch(() => []) : Promise.resolve([]),
    ]);
    const pm = new Map(prices.map((p) => [p.sku, p]));
    const rows = lines.filter((l) => (l.units || 0) > 0).map((l) => {
      const lb = ctx.lineLabel(l);
      const p = pm.get(l.sku);
      const price = p && Number(p.wholesale) > 0 ? Number(p.wholesale) : null;
      return { sku: l.sku, ean: codes.get(l.sku) || '', name: lb.name, color: lb.color, size: lb.size, units: l.units, shipped: l.units_shipped,
        price, amount: price != null ? Math.round(price * l.units * 100) / 100 : null, cur: (p && p.currency) || o.currency || 'EUR' };
    }).sort((a, b) => a.name.localeCompare(b.name) || a.color.localeCompare(b.color) || sizeIdx(a.size) - sizeIdx(b.size));
    const company = ctx.companyById(o.company_id) || {};
    const units = rows.reduce((a, r) => a + r.units, 0);
    const priced = rows.every((r) => r.price != null);
    const total = priced ? Math.round(rows.reduce((a, r) => a + r.amount, 0) * 100) / 100 : null;
    return { rows, company, units, total, cur: (rows[0] && rows[0].cur) || 'EUR' };
  }

  async function orderXlsx(o, ctx) {
    const d = await orderData(o, ctx);
    const header = [t('ff_sku'), t('ff_ean'), t('ff_style'), t('ff_color'), t('ff_size'), t('ff_qty'), t('ff_shipped'), t('ff_wholesale'), t('ff_amount'), t('ff_currency')];
    const rows = d.rows.map((r) => [r.sku, r.ean, r.name, r.color, r.size, r.units, r.shipped, r.price, r.amount, r.cur]);
    rows.push(['', '', t('ff_total'), '', '', d.units, '', '', d.total, d.total != null ? d.cur : '']);
    await downloadXlsx(o.ref, header, rows, `SES-pedido-${slug(o.ref)}`, [16, 15, 22, 16, 7, 7, 9, 14, 12, 8]);
  }

  async function orderPdf(o, ctx) {
    const [d] = await Promise.all([orderData(o, ctx), lib('pdf')]);
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
    const W = doc.internal.pageSize.getWidth();
    const M = 40;
    const ink = [28, 26, 23], muted = [107, 101, 92], gold = [201, 168, 124];
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...ink);
    doc.setFontSize(15); doc.setCharSpace(3); doc.text('SES PALMA', M, 52); doc.setCharSpace(0);
    doc.setFontSize(8); doc.setTextColor(...muted); doc.text('WHOLESALE · sespalma.com', M, 66);
    doc.setDrawColor(...gold); doc.setLineWidth(0.6); doc.line(M, 80, W - M, 80);
    doc.setTextColor(...ink); doc.setFontSize(16);
    doc.text(t('ff_order_t', { ref: o.ref }), M, 108);
    doc.setFontSize(9); doc.setTextColor(...muted);
    const meta = [
      [t('ff_company'), d.company.legal_name || d.company.name || ''],
      [t('ff_date'), o.ordered_at ? B.fmtDate(o.ordered_at) : ''],
      [t('ff_season'), o.season || ''],
      [t('ff_status'), t('os_' + o.status)],
    ].filter((x) => x[1]);
    meta.forEach(([k, v], i) => { doc.text(`${k}: `, M, 128 + i * 13); doc.setTextColor(...ink); doc.text(String(v), M + 70, 128 + i * 13); doc.setTextColor(...muted); });
    const startY = 128 + meta.length * 13 + 14;
    const money = (n, cur) => (n == null ? '' : B.fmtAmount(n, cur));
    doc.autoTable({
      startY, margin: { left: M, right: M },
      head: [[t('ff_style'), t('ff_color'), t('ff_size'), t('ff_sku'), t('ff_ean'), t('ff_qty'), t('ff_shipped'), t('ff_wholesale'), t('ff_amount')]],
      body: d.rows.map((r) => [r.name, r.color, r.size, r.sku, r.ean, B.fmtInt(r.units), r.shipped != null ? B.fmtInt(r.shipped) : '', money(r.price, r.cur), money(r.amount, r.cur)]),
      foot: [[t('ff_total'), '', '', '', '', B.fmtInt(d.units), '', '', money(d.total, d.cur)]],
      styles: { font: 'helvetica', fontSize: 7.5, textColor: ink, cellPadding: { top: 4, bottom: 4, left: 3, right: 3 }, lineColor: [228, 223, 214], lineWidth: { bottom: 0.4 } },
      headStyles: { fillColor: [255, 255, 255], textColor: muted, fontStyle: 'normal', fontSize: 7, lineWidth: { bottom: 0.8 }, lineColor: ink },
      footStyles: { fillColor: [255, 255, 255], textColor: ink, fontStyle: 'bold', lineWidth: { top: 0.8 }, lineColor: ink },
      columnStyles: { 5: { halign: 'right' }, 6: { halign: 'right' }, 7: { halign: 'right' }, 8: { halign: 'right' } },
      didParseCell: (h) => { if ([5, 6, 7, 8].includes(h.column.index)) h.cell.styles.halign = 'right'; },
    });
    let y = doc.lastAutoTable.finalY + 18;
    doc.setFontSize(8); doc.setTextColor(...muted);
    doc.text(doc.splitTextToSize(t('ff_price_note'), W - 2 * M), M, y);
    // Facturado solo con factura (INVOICED/CLOSED); antes es el valor a la tarifa del cliente.
    const amountLabel = o.status === 'INVOICED' || o.status === 'CLOSED' ? 'ff_invoiced' : 'ff_order_value';
    if (o.amount != null) { y += 14; doc.setTextColor(...ink); doc.text(`${t(amountLabel)}: ${money(o.amount, o.currency)}`, M, y); }
    const pages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pages; i++) {
      doc.setPage(i); doc.setFontSize(7); doc.setTextColor(...muted);
      doc.text(t('ff_generated', { date: B.fmtDateTime(new Date().toISOString()) }), M, doc.internal.pageSize.getHeight() - 24);
      doc.text(`${i} / ${pages}`, W - M, doc.internal.pageSize.getHeight() - 24, { align: 'right' });
    }
    doc.save(`SES-pedido-${slug(o.ref)}.pdf`);
  }

  /* ---------- recepción ---------- */
  function openReceipt(s, lines, ctx, trigger, season) {
    const uid = 'rc' + Math.random().toString(36).slice(2, 7);
    const rows = lines.map((l) => Object.assign({}, l, ctx.lineLabel(l)))
      .sort((a, b) => a.name.localeCompare(b.name) || a.color.localeCompare(b.color) || sizeIdx(a.size) - sizeIdx(b.size));
    const minDate = s.ship_date || '';
    const body = document.createElement('form');
    body.className = 'ff-rcv';
    body.noValidate = true;
    body.innerHTML = `<p class="b2b-dialog-text ff-rcv-intro">${esc(t('ff_rcv_intro'))}</p>
      <div class="b2b-field ff-rcv-date"><label class="b2b-label" for="${uid}d">${esc(t('ff_rcv_date'))}</label>
        <input class="b2b-input" id="${uid}d" type="date" required value="${today()}" max="${today()}"${minDate ? ` min="${esc(minDate)}"` : ''}></div>
      <ul class="ff-rcv-lines" role="list">${rows.map((r, i) => `<li class="ff-rcv-line" data-sku="${esc(r.sku)}" data-sent="${r.units_sent}">
          <div class="ff-rcv-item"><strong>${esc(r.name)}</strong> <span class="bp-muted">${esc(r.color)} · ${esc(r.size)}</span><span class="ff-code bp-small">${esc(r.sku)}</span></div>
          <div class="ff-rcv-qty">
            <span class="ff-rcv-sent"><span class="b2b-label">${esc(t('ff_rcv_sent'))}</span><span class="u-tnum">${B.fmtInt(r.units_sent)}</span></span>
            <label class="ff-rcv-got"><span class="b2b-label">${esc(t('ff_rcv_got'))}</span>
              <input class="b2b-input u-tnum" type="number" inputmode="numeric" min="0" max="99999" step="1" value="${r.units_sent}" data-got aria-describedby="${uid}n${i}"></label>
            <label class="ff-rcv-issue"><span class="b2b-label">${esc(t('ff_rcv_issue'))}</span>
              <select class="b2b-select" data-inc><option value="">${esc(t('ff_inc_none'))}</option>${INCIDENTS.map((k) => `<option value="${k}">${esc(t('ff_inc_' + k))}</option>`).join('')}</select></label>
          </div>
          <label class="ff-rcv-note" hidden><span class="b2b-label">${esc(t('ff_rcv_note'))}</span><input class="b2b-input" type="text" maxlength="500" data-note></label>
          <p class="bp-muted bp-small ff-rcv-diff" id="${uid}n${i}" aria-live="polite"></p>
        </li>`).join('')}</ul>
      <div class="b2b-field"><label class="b2b-label" for="${uid}c">${esc(t('ff_rcv_comment'))}</label>
        <textarea class="b2b-textarea" id="${uid}c" maxlength="2000" rows="3"></textarea></div>
      <p class="ff-rcv-summary" role="status" aria-live="polite"></p>
      <p class="bp-error-inline ff-rcv-err" role="alert" hidden></p>
      <div class="ff-rcv-foot">
        <button type="button" class="b2b-btn b2b-btn--ghost" data-close>${esc(t('cancel'))}</button>
        <button type="submit" class="b2b-btn b2b-btn--primary">${ICON.check}<span>${esc(t('ff_rcv_confirm'))}</span></button>
      </div>`;
    const summary = body.querySelector('.ff-rcv-summary');
    function lineState(li) {
      const sent = Number(li.dataset.sent);
      const raw = li.querySelector('[data-got]').value;
      const got = raw === '' ? NaN : Number(raw);
      const inc = li.querySelector('[data-inc]').value;
      return { sku: li.dataset.sku, sent, got, inc, note: li.querySelector('[data-note]').value.trim(), bad: got !== sent || !!inc };
    }
    let assist = null; // ayudas de lector/cámara/dictado, ver más abajo
    function refresh() {
      let n = 0;
      body.querySelectorAll('.ff-rcv-line').forEach((li) => {
        const x = lineState(li);
        li.classList.toggle('is-issue', x.bad);
        li.querySelector('.ff-rcv-note').hidden = !x.bad;
        const diff = isFinite(x.got) ? x.got - x.sent : 0;
        li.querySelector('.ff-rcv-diff').textContent = diff ? t('ff_rcv_diff', { n: `${diff > 0 ? '+' : '−'}${Math.abs(diff)}` }) : '';
        if (x.bad) n++;
      });
      if (assist) n += assist.foreignLines().length;
      summary.textContent = n ? (n === 1 ? t('ff_rcv_n_inc1') : t('ff_rcv_n_inc', { n })) : t('ff_rcv_ok_all');
      summary.classList.toggle('is-issue', n > 0);
    }
    body.addEventListener('input', refresh);
    body.addEventListener('change', refresh);
    // lector, cámara y dictado (ses-b2b-rcv-ui.js); lo que no es del envío entra como «Artículo equivocado»
    assist = B.rcvAssist ? B.rcvAssist.attach(body, { rows, eans: season ? eans(season) : Promise.resolve(new Map()), root: ctx.root }) : null;
    refresh();
    B.dialog({
      title: t('ff_rcv_title', { ref: s.ref }), body, wide: true, root: ctx.root,
      onMount: (dlg, done) => {
        body.addEventListener('submit', async (e) => {
          e.preventDefault();
          const err = body.querySelector('.ff-rcv-err');
          err.hidden = true;
          const date = body.querySelector('#' + uid + 'd').value;
          const st = [...body.querySelectorAll('.ff-rcv-line')].map(lineState);
          const badQty = st.find((x) => !Number.isInteger(x.got) || x.got < 0 || x.got > 99999);
          const needNote = st.find((x) => x.inc === 'OTHER' && !x.note);
          if (!date || badQty || needNote) {
            err.textContent = !date ? B.errorMessage('invalid_date') : badQty ? B.errorMessage('invalid_qty') : t('ff_rcv_note_req');
            err.hidden = false;
            const focusEl = !date ? body.querySelector('#' + uid + 'd')
              : body.querySelector(`.ff-rcv-line[data-sku="${CSS.escape((badQty || needNote).sku)}"] ${badQty ? '[data-got]' : '[data-note]'}`);
            if (focusEl) focusEl.focus();
            return;
          }
          const btn = body.querySelector('[type="submit"]');
          btn.disabled = true;
          btn.lastElementChild.textContent = t('ff_rcv_sending');
          const r = await B.rpc('portal_confirm_receipt', {
            p_shipment: s.id, p_received_on: date, p_comment: body.querySelector('#' + uid + 'c').value.trim() || null,
            p_lines: st.map((x) => ({ sku: x.sku, received: x.got, incident: x.inc || null, note: x.bad && x.note ? x.note : null }))
              .concat(assist ? assist.foreignLines() : []),
          });
          if (r.error) {
            btn.disabled = false;
            btn.lastElementChild.textContent = t('ff_rcv_confirm');
            err.textContent = B.errorMessage(r.code);
            err.hidden = false;
            if (r.code === 'already_received') { done('ok'); ctx.rerender(); }
            return;
          }
          done('ok');
          B.toast(t(r.data && r.data.has_incidents ? 'ff_rcv_done_inc' : 'ff_rcv_done'), 'ok', { root: ctx.root });
          ctx.rerender();
        });
      },
    }).then(() => {
      if (assist) assist.destroy();
      if (trigger && document.contains(trigger)) trigger.focus();
    });
  }

  // utilidades compartidas con otras vistas (reporte de ventas)
  B.portalFulfil = { enhancePrices, enhanceOrders, lib, downloadCsv, downloadXlsx, busy, eans, slug };
})();
